import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import {
  FALLBACK_UI_LOCALE,
  SUPPORTED_UI_LOCALES,
  detectInitialLocale,
  normalizeLocale,
  isRtlLocale,
} from "./config";

import enApp from "./locales/en/app.json";
import enNavigation from "./locales/en/navigation.json";
import enAuth from "./locales/en/auth.json";
import enToasts from "./locales/en/toasts.json";
import enSettings from "./locales/en/settings.json";
import enOverview from "./locales/en/overview.json";
import enOrders from "./locales/en/orders.json";
import enCustomers from "./locales/en/customers.json";
import enConversations from "./locales/en/conversations.json";
import enReports from "./locales/en/reports.json";
import enCampaigns from "./locales/en/campaigns.json";
import enDiscounts from "./locales/en/discounts.json";
import enDelivery from "./locales/en/delivery.json";
import enIntegrations from "./locales/en/integrations.json";
import enStores from "./locales/en/stores.json";
import enProducts from "./locales/en/products.json";
import enBrands from "./locales/en/brands.json";
import enAiAgents from "./locales/en/aiAgents.json";
import enWhiteLabel from "./locales/en/whiteLabel.json";
import enProfile from "./locales/en/profile.json";
import enAccount from "./locales/en/account.json";
import enSupport from "./locales/en/support.json";
import enAgentTranslations from "./locales/en/agentTranslations.json";
import enCommon from "./locales/en/common.json";
import enDownloadApp from "./locales/en/downloadApp.json";
import enBilling from "./locales/en/billing.json";
import enMenuImporters from "./locales/en/menuImporters.json";
import enLinkInBioPublic from "./locales/en/linkInBioPublic.json";
import enLinkInBio from "./locales/en/linkInBio.json";
import enCartRecovery from "./locales/en/cartRecovery.json";
import enMetaAds from "./locales/en/metaAds.json";

import esApp from "./locales/es/app.json";
import esNavigation from "./locales/es/navigation.json";
import esAuth from "./locales/es/auth.json";
import esToasts from "./locales/es/toasts.json";
import esSettings from "./locales/es/settings.json";
import esOverview from "./locales/es/overview.json";
import esOrders from "./locales/es/orders.json";
import esCustomers from "./locales/es/customers.json";
import esConversations from "./locales/es/conversations.json";
import esReports from "./locales/es/reports.json";
import esCampaigns from "./locales/es/campaigns.json";
import esDiscounts from "./locales/es/discounts.json";
import esDelivery from "./locales/es/delivery.json";
import esIntegrations from "./locales/es/integrations.json";
import esStores from "./locales/es/stores.json";
import esProducts from "./locales/es/products.json";
import esBrands from "./locales/es/brands.json";
import esAiAgents from "./locales/es/aiAgents.json";
import esWhiteLabel from "./locales/es/whiteLabel.json";
import esProfile from "./locales/es/profile.json";
import esAccount from "./locales/es/account.json";
import esSupport from "./locales/es/support.json";
import esAgentTranslations from "./locales/es/agentTranslations.json";
import esCommon from "./locales/es/common.json";
import esDownloadApp from "./locales/es/downloadApp.json";
import esBilling from "./locales/es/billing.json";
import esMenuImporters from "./locales/es/menuImporters.json";
import esLinkInBioPublic from "./locales/es/linkInBioPublic.json";
import esLinkInBio from "./locales/es/linkInBio.json";
import esCartRecovery from "./locales/es/cartRecovery.json";
import esMetaAds from "./locales/es/metaAds.json";

import frApp from "./locales/fr/app.json";
import frNavigation from "./locales/fr/navigation.json";
import frAuth from "./locales/fr/auth.json";
import frToasts from "./locales/fr/toasts.json";
import frSettings from "./locales/fr/settings.json";
import frOverview from "./locales/fr/overview.json";
import frOrders from "./locales/fr/orders.json";
import frCustomers from "./locales/fr/customers.json";
import frConversations from "./locales/fr/conversations.json";
import frReports from "./locales/fr/reports.json";
import frCampaigns from "./locales/fr/campaigns.json";
import frDiscounts from "./locales/fr/discounts.json";
import frDelivery from "./locales/fr/delivery.json";
import frIntegrations from "./locales/fr/integrations.json";
import frStores from "./locales/fr/stores.json";
import frProducts from "./locales/fr/products.json";
import frBrands from "./locales/fr/brands.json";
import frAiAgents from "./locales/fr/aiAgents.json";
import frWhiteLabel from "./locales/fr/whiteLabel.json";
import frProfile from "./locales/fr/profile.json";
import frAccount from "./locales/fr/account.json";
import frSupport from "./locales/fr/support.json";
import frAgentTranslations from "./locales/fr/agentTranslations.json";
import frCommon from "./locales/fr/common.json";
import frDownloadApp from "./locales/fr/downloadApp.json";
import frBilling from "./locales/fr/billing.json";
import frMenuImporters from "./locales/fr/menuImporters.json";
import frLinkInBioPublic from "./locales/fr/linkInBioPublic.json";
import frLinkInBio from "./locales/fr/linkInBio.json";
import frCartRecovery from "./locales/fr/cartRecovery.json";
import frMetaAds from "./locales/fr/metaAds.json";

import arApp from "./locales/ar/app.json";
import arNavigation from "./locales/ar/navigation.json";
import arAuth from "./locales/ar/auth.json";
import arToasts from "./locales/ar/toasts.json";
import arSettings from "./locales/ar/settings.json";
import arOverview from "./locales/ar/overview.json";
import arOrders from "./locales/ar/orders.json";
import arCustomers from "./locales/ar/customers.json";
import arConversations from "./locales/ar/conversations.json";
import arReports from "./locales/ar/reports.json";
import arCampaigns from "./locales/ar/campaigns.json";
import arDiscounts from "./locales/ar/discounts.json";
import arDelivery from "./locales/ar/delivery.json";
import arIntegrations from "./locales/ar/integrations.json";
import arStores from "./locales/ar/stores.json";
import arProducts from "./locales/ar/products.json";
import arBrands from "./locales/ar/brands.json";
import arAiAgents from "./locales/ar/aiAgents.json";
import arWhiteLabel from "./locales/ar/whiteLabel.json";
import arProfile from "./locales/ar/profile.json";
import arAccount from "./locales/ar/account.json";
import arSupport from "./locales/ar/support.json";
import arAgentTranslations from "./locales/ar/agentTranslations.json";
import arCommon from "./locales/ar/common.json";
import arDownloadApp from "./locales/ar/downloadApp.json";
import arBilling from "./locales/ar/billing.json";
import arMenuImporters from "./locales/ar/menuImporters.json";
import arLinkInBioPublic from "./locales/ar/linkInBioPublic.json";
import arLinkInBio from "./locales/ar/linkInBio.json";
import arCartRecovery from "./locales/ar/cartRecovery.json";
import arMetaAds from "./locales/ar/metaAds.json";

export const I18N_NAMESPACES = [
  "app",
  "navigation",
  "auth",
  "toasts",
  "settings",
  "overview",
  "orders",
  "customers",
  "conversations",
  "reports",
  "campaigns",
  "discounts",
  "delivery",
  "integrations",
  "stores",
  "products",
  "brands",
  "aiAgents",
  "whiteLabel",
  "profile",
  "account",
  "support",
  "agentTranslations",
  "common",
  "downloadApp",
  "billing",
  "menuImporters",
  "linkInBioPublic",
  "linkInBio",
  "cartRecovery",
  "metaAds",
];

const resources = {
  en: {
    app: enApp,
    navigation: enNavigation,
    auth: enAuth,
    toasts: enToasts,
    settings: enSettings,
    overview: enOverview,
    orders: enOrders,
    customers: enCustomers,
    conversations: enConversations,
    reports: enReports,
    campaigns: enCampaigns,
    discounts: enDiscounts,
    delivery: enDelivery,
    integrations: enIntegrations,
    stores: enStores,
    products: enProducts,
    brands: enBrands,
    aiAgents: enAiAgents,
    whiteLabel: enWhiteLabel,
    profile: enProfile,
    account: enAccount,
    support: enSupport,
    agentTranslations: enAgentTranslations,
    common: enCommon,
    downloadApp: enDownloadApp,
    billing: enBilling,
    menuImporters: enMenuImporters,
    linkInBioPublic: enLinkInBioPublic,
    linkInBio: enLinkInBio,
    cartRecovery: enCartRecovery,
    metaAds: enMetaAds,
  },
  es: {
    app: esApp,
    navigation: esNavigation,
    auth: esAuth,
    toasts: esToasts,
    settings: esSettings,
    overview: esOverview,
    orders: esOrders,
    customers: esCustomers,
    conversations: esConversations,
    reports: esReports,
    campaigns: esCampaigns,
    discounts: esDiscounts,
    delivery: esDelivery,
    integrations: esIntegrations,
    stores: esStores,
    products: esProducts,
    brands: esBrands,
    aiAgents: esAiAgents,
    whiteLabel: esWhiteLabel,
    profile: esProfile,
    account: esAccount,
    support: esSupport,
    agentTranslations: esAgentTranslations,
    common: esCommon,
    downloadApp: esDownloadApp,
    billing: esBilling,
    menuImporters: esMenuImporters,
    linkInBioPublic: esLinkInBioPublic,
    linkInBio: esLinkInBio,
    cartRecovery: esCartRecovery,
    metaAds: esMetaAds,
  },
  fr: {
    app: frApp,
    navigation: frNavigation,
    auth: frAuth,
    toasts: frToasts,
    settings: frSettings,
    overview: frOverview,
    orders: frOrders,
    customers: frCustomers,
    conversations: frConversations,
    reports: frReports,
    campaigns: frCampaigns,
    discounts: frDiscounts,
    delivery: frDelivery,
    integrations: frIntegrations,
    stores: frStores,
    products: frProducts,
    brands: frBrands,
    aiAgents: frAiAgents,
    whiteLabel: frWhiteLabel,
    profile: frProfile,
    account: frAccount,
    support: frSupport,
    agentTranslations: frAgentTranslations,
    common: frCommon,
    downloadApp: frDownloadApp,
    billing: frBilling,
    menuImporters: frMenuImporters,
    linkInBioPublic: frLinkInBioPublic,
    linkInBio: frLinkInBio,
    cartRecovery: frCartRecovery,
    metaAds: frMetaAds,
  },
  ar: {
    app: arApp,
    navigation: arNavigation,
    auth: arAuth,
    toasts: arToasts,
    settings: arSettings,
    overview: arOverview,
    orders: arOrders,
    customers: arCustomers,
    conversations: arConversations,
    reports: arReports,
    campaigns: arCampaigns,
    discounts: arDiscounts,
    delivery: arDelivery,
    integrations: arIntegrations,
    stores: arStores,
    products: arProducts,
    brands: arBrands,
    aiAgents: arAiAgents,
    whiteLabel: arWhiteLabel,
    profile: arProfile,
    account: arAccount,
    support: arSupport,
    agentTranslations: arAgentTranslations,
    common: arCommon,
    downloadApp: arDownloadApp,
    billing: arBilling,
    menuImporters: arMenuImporters,
    linkInBioPublic: arLinkInBioPublic,
    linkInBio: arLinkInBio,
    cartRecovery: arCartRecovery,
    metaAds: arMetaAds,
  },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    resources,
    lng: detectInitialLocale(),
    fallbackLng: FALLBACK_UI_LOCALE,
    supportedLngs: SUPPORTED_UI_LOCALES,
    load: "currentOnly",
    nonExplicitSupportedLngs: true,
    ns: I18N_NAMESPACES,
    defaultNS: "app",
    fallbackNS: "app",
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    showSupportNotice: false,
    returnEmptyString: false,
    parseMissingKeyHandler: (key) => {
      if (import.meta.env.MODE !== "test") {
        console.warn(`[i18n] Missing translation key: ${key}`);
      }
      return key;
    },
  });

  if (typeof document !== "undefined") {
    const initialLocale = normalizeLocale(
      i18n.resolvedLanguage || i18n.language,
    );
    document.documentElement.lang = initialLocale;
    document.documentElement.dir = isRtlLocale(initialLocale) ? "rtl" : "ltr";

    i18n.on("languageChanged", (language) => {
      const normalized = normalizeLocale(language);
      document.documentElement.lang = normalized;
      document.documentElement.dir = isRtlLocale(normalized) ? "rtl" : "ltr";
    });
  }
}

export default i18n;
